import React, { Suspense, useState, useEffect } from "react";
import "./Basic_info.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {  useHistory } from "react-router-dom";
import {
  Button,
  Form,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from "reactstrap";
import { FaFileUpload } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading";
import { logout } from '../../actions/authActions'
import Footer from "../../DefaultLayout/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import $ from "jquery";
import { BsArrowRight, BsCheck2 } from "react-icons/bs";
import { connect, useSelector } from "react-redux";
import {
  checkEmailValidation,
  checkEmptyValidation,checkRequiredValidationWithMinMax,checkRequiredTextValidationWithMinMax
} from "../../Helpers/Validation";
import { addBasicInfo ,getUserDetailsFromSocialId} from "../../actions/authActions";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { toast } from "react-toastify";
import {
 
  CircularProgress,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop"; 

const Basic_info = (props) => {
 
  let isSubscribing =localStorage.getItem("isSubscribing")==="true"

  const dispatch = useDispatch();
  const history = useHistory();
  const { frontLabelsName } = props.label;
  const [modal, setModal] = useState(false);
  const modalHandle = () => setModal(!modal);

  const [full_name, setFull_name] = useState("");
  const [email, setEmail] = useState("");
  const [profile_pic, setProfile_pic] = useState("");
  const [address, setAddress] = useState("");
  const[nationality,setNationality]= useState("");
  const [password, setPassword] = useState("");
  const [confirm_pass, setConfirm_pass] = useState("");
  const [ss_number, setSs_number] = useState("");
  const [zcode, setZcode] = useState("");
  const [imagePreview, setPreview] = useState("");
  const [imagePreview1, setPreview1] = useState("");
  const [imagePreviewUrl, setUrl] = useState("");
  const [imagePreviewUrl1, setUrl1] = useState("");
  const[loader,setLoader] = React.useState(false);
  const[disableSubmitButton,setDisableSubmitButton]=useState(false)
  const userInfo = useSelector((state) => state.auth.user);

  const [errors, setErrors] = useState({
    errorName: "",
    errorEmail: "",
    errorAddress: "",
    errorPassword: "",
    errorConfirmPass: "",
    errorSs: "",
    errorZCode: "",
    errorNationality:""
  });



  useEffect(() => {
    
    setFull_name(userInfo?.full_name);
    setEmail(userInfo?.email);
    setProfile_pic(userInfo?.profile_pic);
    setAddress(userInfo?.address);
    setSs_number(userInfo?.ss_number);
    setZcode(userInfo?.zcode);
    setProfile_pic(userInfo?.profile_pic);
    setNationality(userInfo?.nationality ?userInfo?.nationality :"")
  }, [userInfo]);

  const handleFileChange = (e) => {
    e.preventDefault();
    let validationFlag = true;

    if (e.target.files.length) {
      let file = e.target.files[0];

      if (validationFlag) {
        // setUrl(file);
        setUrl1(file);
        setPreview(URL.createObjectURL(e.target.files[0]));
      }
    }
  };

  const handleUpload = () => {
    $("#handleupload").trigger("click");
  };

  const confirmImage = () => {
    setPreview1(imagePreview);
    setUrl(imagePreviewUrl1);
    setModal(!modal);
    setPreview("");
    setUrl1("");
  };

  const cancelImage = () => {
    setUrl1("");
    setModal(!modal);
    setPreview("");
  };

  const onSubmitForm = () => {
    let validationFlag = true;

    let err_name = "";
    let err_email = "";
    let err_address = "";
    let err_pass = "";
    let err_confirm_pass = "";
    let err_ss = "";
    let err_z_code = "";
    let err_nationality=""

    err_name = checkRequiredTextValidationWithMinMax(full_name, "lbl_full_name",2,50);
    err_email = checkEmailValidation(email, "lbl_email");
    err_address = checkRequiredValidationWithMinMax(address, "lbl_address",5,100);
    err_ss = checkRequiredValidationWithMinMax(ss_number, "lbl_social_security_no",7,11);
    err_z_code = checkRequiredValidationWithMinMax(zcode, "lbl_zip_code",2,10);
    err_nationality= checkRequiredValidationWithMinMax(nationality, "lbl_nationality",2,15);

    if (!userInfo?.isBasicInfoAdded) {
      err_pass = checkEmptyValidation(password, "lbl_password");
      err_confirm_pass = checkEmptyValidation(
        confirm_pass,
        "lbl_confirm_password"
      );
    }

    if (err_name || err_email || err_address || err_ss || err_z_code||err_pass||err_confirm_pass||err_nationality) {
      validationFlag = false;
      setErrors({
        errorName: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_name).length > 0
            ? frontLabelsName.filter((e) => e.key == err_name)[0]["value"] ||
              err_name
            : err_name
          : err_name,
        errorEmail: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_email).length > 0
            ? frontLabelsName.filter((e) => e.key == err_email)[0]["value"] ||
              err_email
            : err_email
          : err_email,
        errorAddress: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_address).length > 0
            ? frontLabelsName.filter((e) => e.key == err_address)[0]["value"] ||
              err_address
            : err_address
          : err_address,
        errorSs: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_ss).length > 0
            ? frontLabelsName.filter((e) => e.key == err_ss)[0]["value"] || err_ss
            : err_ss
          : err_ss,
        errorZCode: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_z_code).length > 0
            ? frontLabelsName.filter((e) => e.key == err_z_code)[0]["value"] ||
              err_z_code
            : err_z_code
          : err_z_code,
        errorPassword: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_pass).length > 0
            ? frontLabelsName.filter((e) => e.key == err_pass)[0]["value"] ||
              err_pass
            : err_pass
          : err_pass,
        errorConfirmPass: frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_confirm_pass).length > 0
            ? frontLabelsName.filter((e) => e.key == err_confirm_pass)[0]["value"] ||
              err_confirm_pass
            : err_confirm_pass
          : err_confirm_pass,
          errorNationality:frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_nationality).length > 0
            ? frontLabelsName.filter((e) => e.key == err_nationality)[0]["value"] ||
            err_nationality
            : err_nationality
          : err_nationality,
      });
    } else {
      validationFlag = true;
      setErrors({
        errorName: "",
        errorEmail: "",
        errorAddress: "",
        errorPassword: "",
        errorConfirmPass: "",
        errorSs: "",
        errorZCode: "",
        errorNationality:""
      });
    }

    if (password !== "") {
      if (password !== confirm_pass) {
        validationFlag = false;
        setErrors({
          errorConfirmPass: frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_password_not_matching")
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == "lbl_password_not_matching"
                )[0]["value"] || "lbl_password_not_matching"
              : "lbl_password_not_matching"
            : "lbl_password_not_matching",
        });
      }
    }

    if (validationFlag) {
      setDisableSubmitButton(true)
      const formData = new FormData();
      formData.append("full_name", full_name);
      formData.append("email", email);
      if (password != "") {
        formData.append("password", password);
        formData.append("confirm_pass", confirm_pass);
      }
      formData.append("nationality", nationality);
      formData.append("ss_number", ss_number);
      formData.append("zcode", zcode);
      formData.append("address", address);
      formData.append("profile_pic", imagePreviewUrl);
      formData.append("isSubscribing", isSubscribing)

      props
        .addBasicInfo(formData)
        .then((res) => {
          setDisableSubmitButton(false)
          if (res.data) {
            toast.success(
              frontLabelsName
                ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
                  ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                      "value"
                    ] || res.data.message
                  : res.data.message
                : res.data.message
            );
            dispatch({
              type:"SET_STEP",
              payload:{step:2,status:true}
           });
           localStorage.setItem("currentStepIndex", 2)
            history.push(  "/register-tenant-profile");
          }else if(res?.response?.data?.message){
           if(res?.response?.status==401){
          
            history.push( "/login")
                                     dispatch({
                                       type:"SET_STEP",
                                       payload:{step:0,status:false}
                                    });
                                    localStorage.removeItem("isSubscribing")
                               
                                     props.logout()
                                    
                                 
            }
            toast.error(
              frontLabelsName
                ? frontLabelsName.filter((e) => e.key == res.response.data.message)
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == res.response.data.message
                    )[0]["value"] || res.response.data.message
                  : res.response.data.message
                : res.response.data.message
            );
          }
        })
        .catch((err) => {
         
          setDisableSubmitButton(false)
          toast.error(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                  .length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == err.response.data.message
                  )[0]["value"] || err.response.data.message
                : err.response.data.message
              : err.response.data.message
          );
          // setBtnLoading(false);
        });
    }
  };

  const handleClick=(id)=>{
 
    if(id?.length>=7 && id?.length<=11){
      setErrors((prevErrors) => ({
        ...prevErrors,
        errorSs: "",
      }));
    setLoader(true)
    props.getUserDetailsFromSocialId(id).then((res)=>{
      setLoader(false)
      if(res.status==200){
        setFull_name(res?.data?.result?.subject?.name)
        setAddress(res?.data?.result?.subject?.legalAddress)
        setZcode(res?.data?.result?.subject?.legalPostalCode)
      }else{
        toast.error( 
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == 'The security number provided is invalid or incorrect')
                .length > 0
              ? frontLabelsName.filter(
                  (e) => e.key == 'The security number provided is invalid or incorrect'
                )[0]["value"] ||'The security number provided is invalid or incorrect'
              : 'The security number provided is invalid or incorrect'
            :'The security number provided is invalid or incorrect'
        );
      }
  
    
           }).catch((err)=>{
      
     
            setLoader(false)
       
       
           })
          }else{
            let   err_sss = checkRequiredValidationWithMinMax(ss_number, "lbl_social_security_no",7,11);
            setErrors((prevErrors) => ({
              ...prevErrors,
              errorSs: frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err_sss).length > 0
                ? frontLabelsName.filter((e) => e.key == err_sss)[0]["value"] || err_sss
                : err_sss
              : err_sss,
            }));
          }

  }

  return (
    <React.Fragment>
       <Backdrop sx={{ color: "gray", zIndex: 2000 }} open={loader}>
    <CircularProgress
       sx={{
        ":hover": { color: "#000" },
        color: "#000",
        height: "400px",
        width: "400px",
      }}
     
    />
  </Backdrop>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container ">
        <div className="main-renter-info cu-ddd-jj2233  basic-info12">
          <div className="trams-condition-box  d-flex">
            <div className="row">
              <div className="col-lg-9 col-md-12 custom-flex-made-basic-info mb-2">
                <Form className="st-fl-hg-trem-basic1">
                  <div className="set-pdd-basic-info">
                    <div className="register-content1">
                      <h2 className="custom-h2-size1 mb-3">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_basic_info")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_basic_info"
                              )[0]["value"] || "lbl_basic_info"
                            : "lbl_basic_info"
                          : "lbl_basic_info"}
                      </h2>

                      <div className="img-div1">
                        {imagePreview1 ? (
                          <img
                            src={imagePreview1}
                            alt="preview"
                            className="register_img_logo1"
                          />
                        ) : (
                          <img
                            src={profile_pic ? profile_pic :"assets/user.png"}
                            className="register_img_logo1"
                            alt=""
                          />
                        )}

                        <img
                          src="assets/icons/edit-icon.svg"
                          alt="edit-icon"
                          className="FaPlusCircle2 FaPlusCircle22"
                          onClick={modalHandle}
                        />
                      </div>
                    </div>

                    <div className="row d-flex">
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_name")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_name"
                                  )[0]["value"] || "lbl_name"
                                : "lbl_name"
                              : "lbl_name"}{" "}
                            <span className="invalid_span">*</span>
                          </label>
                          <div className="width-100">
                          <input
                            name="full_name"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_name")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_name"
                                    )[0]["value"] || "lbl_name"
                                  : "lbl_name"
                                : "lbl_name"
                            }
                            type="text"
                            className="input_style_info1"
                            value={full_name}
                            onChange={(e) => setFull_name(e.target.value)}
                    
                          />
                          {errors.errorName && (
                            <span className="invalid_span">
                              {errors.errorName}
                            </span>
                          )}
                          </div>
                         
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_social_security_no"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_social_security_no"
                                  )[0]["value"] || "lbl_social_security_no"
                                : "lbl_social_security_no"
                              : "lbl_social_security_no"}{" "}
                            <span className="invalid_span">*</span>
                          </label>
                          <div className="width-100">
                            <div className="d-flex align-items-center gap-1">
                          <input
                            name="ss_number"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_social_security_no"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_social_security_no"
                                    )[0]["value"] || "lbl_social_security_no"
                                  : "lbl_social_security_no"
                                : "lbl_social_security_no"
                            }
                            type="text"
                            className="input_style_info1"
                            value={ss_number}
                            onChange={(e) => setSs_number(e.target.value)}
                          />
                      
                                <FontAwesomeIcon icon={faSearch} style={{ color: '#f5d792 ' ,fontSize:"20px",cursor:"pointer"}} onClick={(e)=>handleClick(ss_number)} />
                              
                          </div>
                          {errors.errorSs && (
                            <p className="invalid_span line-height pt-1">
                              {errors.errorSs}
                            </p>
                          )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_address")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_address"
                                  )[0]["value"] || "lbl_address"
                                : "lbl_address"
                              : "lbl_address"}{" "}
                            <span className="invalid_span">*</span>
                          </label>
                          <div className="width-100">
                          <input
                            name="address"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_address"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_address"
                                    )[0]["value"] || "lbl_address"
                                  : "lbl_address"
                                : "lbl_address"
                            }
                            type="text"
                            className="input_style_info1"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        
                          />
                          {errors.errorAddress && (
                            <span className="invalid_span">
                              {errors.errorAddress}
                            </span>
                          )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_zip_code"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_zip_code"
                                  )[0]["value"] || "lbl_zip_code"
                                : "lbl_zip_code"
                              : "lbl_zip_code"}{" "}
                            <span className="invalid_span">*</span>
                          </label>
                          <div className="width-100">
                          <input
                            name="zcode"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_zip_code"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_zip_code"
                                    )[0]["value"] || "lbl_zip_code"
                                  : "lbl_zip_code"
                                : "lbl_zip_code"
                            }
                            type="text"
                            className="input_style_info1"
                            value={zcode}
                            onChange={(e) => setZcode(e.target.value)}
                            autocomplete="off"
                          
                          />
                          {errors.errorZCode && (
                            <span className="invalid_span">
                              {errors.errorZCode}
                            </span>
                          )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_mobile_no"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_mobile_no"
                                  )[0]["value"] || "lbl_mobile_no"
                                : "lbl_mobile_no"
                              : "lbl_mobile_no"}
                          </label>
                          <div className="width-100">
                          <input
                            name="phone_no"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_mobile_no"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_mobile_no"
                                    )[0]["value"] || "lbl_mobile_no"
                                  : "lbl_mobile_no"
                                : "lbl_mobile_no"
                            }
                            type="Number"
                            className="input_style_info1"
                            value={userInfo?.mobile_number}
                            disabled
                          />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_email")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_email"
                                  )[0]["value"] || "lbl_email"
                                : "lbl_email"
                              : "lbl_email"}{" "}
                            <span className="invalid_span">*</span>
                          </label>
                          <div className="width-100">
                          <input
                            name="email"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_email")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_email"
                                    )[0]["value"] || "lbl_email"
                                  : "lbl_email"
                                : "lbl_email"
                            }
                            type="email"
                            className="input_style_info1"
                            value={email}
                                 autocomplete="off"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          {errors.errorEmail && (
                            <span className="invalid_span">
                              {errors.errorEmail}
                            </span>
                          )}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_password"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_password"
                                  )[0]["value"] || "lbl_password"
                                : "lbl_password"
                              : "lbl_password"}{" "}
                            {userInfo?.isBasicInfoAdded ? (
                              ""
                            ) : (
                              <span className="invalid_span">*</span>
                            )}
                          </label>
                          <div className="width-100">
                          <input
                            name="Password"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_password"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_password"
                                    )[0]["value"] || "lbl_password"
                                  : "lbl_password"
                                : "lbl_password"
                            }
                            type="password"
                            className="input_style_info1"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          {errors.errorPassword && (
                            <span className="invalid_span">
                              {errors.errorPassword}
                            </span>
                          )}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_confirm_password"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_confirm_password"
                                  )[0]["value"] || "lbl_confirm_password"
                                : "lbl_confirm_password"
                              : "lbl_confirm_password"}{" "}
                            {userInfo?.isBasicInfoAdded ? (
                              ""
                            ) : (
                              <span className="invalid_span">*</span>
                            )}
                          </label>
                          <div className="width-100">
                          <input
                            name="confirm_pass"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_confirm_password"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_confirm_password"
                                    )[0]["value"] || "lbl_confirm_password"
                                  : "lbl_confirm_password"
                                : "lbl_confirm_password"
                            }
                            type="password"
                            className="input_style_info1"
                            value={confirm_pass}
                            onChange={(e) => setConfirm_pass(e.target.value)}
                          />
                          {errors.errorConfirmPass && (
                            <span className="invalid_span">
                              {errors.errorConfirmPass}
                            </span>
                          )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div class="set-bg-feild mb-3 d-flex align-items-center">
                          <label className="lbls width-class fw-semibold">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_nationality"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_nationality"
                                  )[0]["value"] || "lbl_nationality"
                                : "lbl_nationality"
                              : "lbl_nationality"}{" "}
                          
                              <span className="invalid_span">*</span>
                          
                          </label>
                          <div className="width-100">
                          <input
                            name="nationality"
                            placeholder={
                              frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_nationality"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_nationality"
                                    )[0]["value"] || "lbl_nationality"
                                  : "lbl_nationality"
                                : "lbl_nationality"
                            }
                            type="text"
                            className="input_style_info1"
                            value={nationality}
                            onChange={(e) => setNationality(e.target.value)}
                          />
                          {errors.errorNationality && (
                            <span className="invalid_span">
                              {errors.errorNationality}
                            </span>
                          )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                      <div className="buton-left-basic-info1  d-flex mt-3">
                      {/* <Link to="/terms-and-condition">Previous</Link> */}
                      <div></div>
                      <Button
                        onClick={onSubmitForm}
                        className="button-basic-style"
                        disabled={disableSubmitButton}
                      >
                        {disableSubmitButton ? (
                        <CircularProgress
                          size={24}
                          sx={{
                            ":hover": { color: "#000" },

                            color: "#000",
                           
                          }}
                        />
                      ) :frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_next")
                              .length > 0
                            ? frontLabelsName.filter((e) => e.key == "lbl_next")[0][
                                "value"
                              ] || "lbl_next"
                            : "lbl_next"
                          : "lbl_next"}
                        <span>
                          <BsArrowRight />
                        </span>
                      </Button>
                    </div>
                      </div>
                    </div>

                
                  </div>
                </Form>
              </div>
              <div className="col-lg-3 col-md-12">
                <div className="black-main">
                  <div className="list-black-main basic-info">
                    <ul>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">1</span>
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_term_condition"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_term_condition"
                                  )[0]["value"] || "lbl_term_condition"
                                : "lbl_term_condition"
                              : "lbl_term_condition"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="yellow-cricle">
                            <BsCheck2 />
                          </span>
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_basic_info"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_basic_info"
                                  )[0]["value"] || "lbl_basic_info"
                                : "lbl_basic_info"
                              : "lbl_basic_info"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">3</span>
                          <p>
                          {
                          frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_tenant_list"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_tenant_list"
                              )[0]["value"] || "lbl_tenant_list"
                            : "lbl_tenant_list"
                          : "lbl_tenant_list"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">4</span>
                          <p>
                          { frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_tenant_profile"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_tenant_profile"
                                  )[0]["value"] || "lbl_tenant_profile"
                                : "lbl_tenant_profile"
                              : "lbl_tenant_profile"}
                          </p>
                        </div>
                      </li>
                      {isSubscribing  &&   <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">5</span>
                          <p>
                          {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_payment"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_payment"
                                  )[0]["value"] || "lbl_payment"
                                : "lbl_payment"
                              : "lbl_payment"}
                          </p>
                        </div>
                      </li>}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={modal} modalHandle={modalHandle}>
        <ModalHeader modalHandle={modalHandle}>
          {frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_add_profile_pic").length >
              0
              ? frontLabelsName.filter((e) => e.key == "lbl_add_profile_pic")[0][
                  "value"
                ] || "lbl_add_profile_pic"
              : "lbl_add_profile_pic"
            : "lbl_add_profile_pic"}
        </ModalHeader>
        <ModalBody>
          <div className="custom-file-input4">
            {/* <input
            type="file"
            placeholder={frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_upload_file").length >
                  0
                  ? frontLabelsName.filter((e) => e.key == "lbl_upload_file")[0][
                      "value"
                    ] || "lbl_upload_file"
                  : "lbl_upload_file"
                : "lbl_upload_file"
            }
            className="custom-file-input1" 
            onChange={handleFileChange}
            accept="image/*"
            id="handleupload"
          /> */}
            <Button
              variant="contained"
              onClick={handleUpload}
              component="label"
              className="upload-button-style"
            >
              <FaFileUpload
                style={{
                  marginRight: 10,
                  color: "#8B9194",
                }}
              />
              {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_upload_file").length >
                  0
                  ? frontLabelsName.filter((e) => e.key == "lbl_upload_file")[0][
                      "value"
                    ] || "lbl_upload_file"
                  : "lbl_upload_file"
                : "lbl_upload_file"}

              <input
                onChange={handleFileChange}
                hidden
                accept="image/*"
                multiple
                type="file"
                className="custom-file-input1"
                id="handleupload"
              />
            </Button>
            {/* <FaFileUpload
            style={{
              position: "absolute",
              top: 32,
              left: 35,
              color: "#8B9194",
            }}
          /> */}
          </div>
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="preview"
              width="150px"
              height="150px"
            />
          ) : imagePreview1 ? (
            <img
              src={imagePreview1}
              alt="preview"
              width="150px"
              height="150px"
            />
          ) : (
            <img src={profile_pic ? profile_pic :"assets/user.png"} alt="preview" width="150px" height="150px" />
          )}
          <p style={{ marginTop: 10, fontSize: 12 }}>
            (
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_image_validation_msg")
                  .length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_image_validation_msg"
                  )[0]["value"] || "lbl_image_validation_msg"
                : "lbl_image_validation_msg"
              : "lbl_image_validation_msg"}
            )
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={confirmImage}
            disabled={imagePreviewUrl1 ? false : true}
          >
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_confirm").length > 0
                ? frontLabelsName.filter((e) => e.key == "lbl_confirm")[0][
                    "value"
                  ] || "lbl_confirm"
                : "lbl_confirm"
              : "lbl_confirm"}
          </Button>{" "}
          <Button color="secondary" onClick={cancelImage}>
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_cancel").length > 0
                ? frontLabelsName.filter((e) => e.key == "lbl_cancel")[0]["value"] ||
                  "lbl_cancel"
                : "lbl_cancel"
              : "lbl_cancel"}
          </Button>
        </ModalFooter>
      </Modal>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});
export default connect(mapStateToProps, {
  addBasicInfo,
  getUserDetailsFromSocialId,
  logout
})(Basic_info);
